import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import LogoutIcon from "@material-ui/icons/MeetingRoom";

import useRequestFunction from "../hooks/useRequestFunction";
import FirebaseContext from "../firebase/context";
import DashboardContext from "../context/DashboardContext";
import ProtocolTable from "../components/ProtocolTable";
import SelectBox from "../components/SelectBox";
import { sortList, getProtocolStatus } from "../utils/functional";
import { BASE_URL, PROTOCOL_STATUS } from "../constants/constants";
import * as Typography from "../components/Typography";

const Dashboard = () => {
  const firebase = useContext(FirebaseContext);
  const { setIsAuthenticated, setUserEmail } = useContext(DashboardContext);
  const [protocolList, setProtocolList] = useState([]);
  const [title, setTitle] = useState("");
  const [classification, setClassification] = useState("");
  const [unity, setUnity] = useState("");
  const [status, setStatus] = useState(PROTOCOL_STATUS.AWAITING_ANSWER);

  const classifications = useRequestFunction("getClassification") || {};
  const classificationList = classifications.hasOwnProperty("values")
    ? classifications.values.sort()
    : [];

  const unitys = useRequestFunction("getUnity") || {};
  const unityList = unitys.hasOwnProperty("values") ? unitys.values.sort() : [];

  useEffect(() => {
    fetchData();

    async function fetchData() {
      try {
        const response = await fetch(`${BASE_URL}/getProtocols`);

        if (response.status === 500) {
          setProtocolList({});
        }

        const data = await response.json();
        setProtocolList(data);
      } catch (err) {
        setProtocolList({});
        console.log(err);
      }
    }
  }, []);

  const filterBy = (protocol) => {
    let isFilter = true;

    if (title && !protocol.title.includes(title)) isFilter = false;

    if (classification && protocol.classification !== classification)
      isFilter = false;

    if (unity && protocol.unity !== unity) isFilter = false;

    if (status && getProtocolStatus(protocol.answers) !== status)
      isFilter = false;

    return isFilter;
  };

  const logout = async () => {
    await firebase.signOut();
    await sessionStorage.clear();
    await setUserEmail("");
    await setIsAuthenticated(false);
  };

  return (
    <Container>
      <Link
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
        color="inherit"
        onClick={logout}
      >
        <LogoutIcon style={{ marginRight: "15px", width: "20px" }} />
        <span style={{ marginTop: "2px" }}>Logout</span>
      </Link>
      <Separator />
      <Separator />
      <Typography.h2>Governança Corporativa</Typography.h2>
      <TextField
        label="Titulo"
        value={title}
        onChange={(e) => setTitle(e.target.value.toUpperCase())}
      />
      <Separator />
      <SelectBox
        title="Classificação"
        value={classification}
        options={classificationList}
        handleChange={(e) => setClassification(e.target.value)}
      />
      <Separator />
      <SelectBox
        title="Unidade"
        value={unity}
        options={unityList}
        handleChange={(e) => setUnity(e.target.value)}
      />
      <Separator />
      <SelectBox
        title="Status"
        value={status}
        options={Object.values(PROTOCOL_STATUS)}
        handleChange={(e) => setStatus(e.target.value)}
      />
      <Separator />
      <Separator />
      <Separator />
      <ProtocolTable
        protocolList={protocolList
          .filter(filterBy)
          .sort(sortList("timestamp", "DESC"))}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 40px;
`;

const Separator = styled.div`
  margin: 10px 0;
`;

export default Dashboard;
